import { coreAxios } from "utilities/axios";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from 'react-toastify';


const BASE_URL = process.env.REACT_APP_MAIN_URL

export const AddSSD = createAsyncThunk(
  "other/AddSSD",
  async (data) => {
    const response = await coreAxios.post(`${BASE_URL}/api/ssd-create/`, data)
    return response.data
  }
); 

export const UpdateSSD = createAsyncThunk(
  "other/UpdateSSD",
  async (data) => {
    const response = await coreAxios.put(`${BASE_URL}/api/ssd-update/${data.id}/`, data)
    return response.data
  }
);

export const GetSSDList = createAsyncThunk(
  "user/GetSSDList",
  async () => {
    const {data} = await coreAxios.get(`${BASE_URL}/api/ssd-list/`)
    return data
  }
);

export const DeleteSSD = createAsyncThunk(
  "other/DeleteSSD",
  async (id) => {
    const response = await coreAxios.delete(`${BASE_URL}/api/ssd-delete/${id}/`)
    if (response.status === 226){
      toast.warning(response.data.message)
    }
    return response.status
  }
);

